import React from 'react';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { formatCurrency } from '../../utils/currencyHelper';
import ItemPriceDialog from './ItemPriceDialog';

const ItemPriceTable = (props) => {
  const { rows, viewField, selectedValues, setRefetchTable, setSelectedValues, addField } = props;
  const theme = useTheme();

  const [openDialog, setOpenDialog] = React.useState(false);
  const [dialogData, setDialogData] = React.useState({
    item: null,
    priceList: null,
  });

  const handleEditClick = (priceList) => {
    setDialogData({
      item: selectedValues.itemCode,
      itemName: selectedValues.itemName,
      priceList: priceList,
      priceListName: rows.find((pl) => pl.id === priceList)?.name || '',
      currencyCode: rows.find((pl) => pl.id === priceList)?.currency.code || '',
    });
    setOpenDialog(true);
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
        <Table size="small" stickyHeader sx={{ tableLayout: 'fixed', width: '100%' }}>
          <TableHead
            sx={{
              '& .MuiTableCell-head': {
                backgroundColor: '#BDE0FB',
                color: theme.palette.text.primary,
                borderBottom: 1,
                borderColor: 'divider',
              },
            }}
          >
            <TableRow>
              <TableCell colSpan={2} sx={{ width: '30%' }}>
                Árlista neve
              </TableCell>
              <TableCell sx={{ width: '40%' }}>Ár</TableCell>
              <TableCell align="center" sx={{ width: '30%' }}>
                Pénznem kódja
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.id} hover sx={{ backgroundColor: index % 2 === 0 ? 'grey.50' : 'inherit' }}>
                <TableCell colSpan={2}>{row.name}</TableCell>
                <TableCell>
                  <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ flex: 1 }}>
                      {row.price ? (
                        formatCurrency(row.price)
                      ) : (
                        <Typography sx={{ color: 'error.main' }}>Nincs érvényes ár!</Typography>
                      )}
                    </Box>
                    <Tooltip title="Szerkesztés">
                      <IconButton
                        size="small"
                        disabled={viewField || !addField}
                        onClick={() => handleEditClick(row.id)}
                      >
                        <EditOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
                <TableCell align="center">{row.currency.code}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ItemPriceDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        data={dialogData}
        setRefetchTable={setRefetchTable}
        setSelectedValues={setSelectedValues}
      />
    </>
  );
};

export default ItemPriceTable;
